import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';

export const Container = styled.div`
  padding: 8px 0;
`;

export const ModuleItem = styled(ListItem)`
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  ${(props) =>
    props.selected &&
    `
    background-color: #e3f2fd;
    border-left: 4px solid ${props.theme?.primary || '#122D58'};
  `}
`;

export const ModuleIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color || '#122D58'}15;
  color: ${(props) => props.color || '#122D58'};
`;

export const ModuleName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #122d58;
`;

export const ModuleDescription = styled.p`
  font-size: 12px;
  color: #7b7b7b;
  margin: 4px 0 0 0;
`;

export const CurrentModuleBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #44DD30;
  background-color: #44DD3015;
  padding: 2px 8px;
  border-radius: 12px;
`;

